import Papa from 'papaparse';

function transformCSVToPerColumn(data) {
  if (!data || !data.length) return data;
  const perColumnData = [];

  for (let i = 0; i < data.length; i++) {
    const rowData = data[i];
    for (let j = 0; j < rowData.length; j++) {
      if (!perColumnData[j]) perColumnData[j] = [];

      perColumnData[j].push(rowData[j]);
    }
  }

  return perColumnData;
}

export default {
  parse(data, { worker, perColumn, delimiter = '' }) {
    return new Promise((resolve, reject) => {
      Papa.parse(data, {
        delimiter,
        worker,
        error: reject,
        complete: ({ data, meta, errors }) => {
          if (perColumn)
            resolve({ meta, data: transformCSVToPerColumn(data), errors });
          else resolve({ meta, data, errors });
        },
      });
    });
  },
};
